import React from 'react';
import { Copy } from '@salesperformanceint/e4shared';

export const NoResults = ({ title, message, extra }) => {
    return (
        <div className="text-center flex flex-column p10" style={{ alignItems: 'center' }}>
            <div className="" style={{ maxWidth: '400px' }}>
                <h2 style={{ marginTop: 0 }}>{title}</h2>
                {message &&
                    message.split('\n').map((p, i) => (
                        <p key={`para-${i}`}>
                            <Copy value={p} />
                        </p>
                    ))}
                {extra}
            </div>
        </div>
    );
};

export default NoResults;
